import { render, staticRenderFns } from "./specialist.vue?vue&type=template&id=72b4201e&scoped=true"
import script from "./specialist.vue?vue&type=script&lang=js"
export * from "./specialist.vue?vue&type=script&lang=js"
import style0 from "./specialist.vue?vue&type=style&index=0&id=72b4201e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b4201e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TopSectionTitle: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/TopSectionTitle.vue').default,BtnReadmore: require('/home/runner/work/dena.ai.renewal/dena.ai.renewal/frontend/components/common/btn-readmore.vue').default})
